import { axiosInterceptor, apiCall } from 'services'
import { API_BASE_URL } from './constants'

const usersService = () => {
	const api = axiosInterceptor(API_BASE_URL)

	// CREATE

	// READ
	const initializeUsers = async () => await apiCall(api.get(`/users`))

	// UPDATE

	/**
	 * Changes the signed-in user's password.
	 *
	 * Goes through `axiosInterceptor` so the Bearer token is attached. The
	 * profile screens previously called bare `axios` with only a Content-Type
	 * header, so `protect` rejected every attempt with a 401 and the UI
	 * mislabelled it "Incorrect password".
	 *
	 * The identity is taken from the token server-side; no email is sent.
	 */
	const updatePassword = async (payload: { oldPassword: string; newPassword: string }) =>
		await apiCall(api.post('/users/updatePassword', payload))

	// DELETE

	//OTHER

	return {
		initializeUsers,
		updatePassword,
	}
}

export default usersService
